import React from 'react';

/**
 * BlackBelt AI Logo Component
 * Uses the official Valdr "V" logo
 */
export function Logo({ className = "w-8 h-8", showText = true, textClassName = "font-heading font-bold text-lg" }) {
  return (
    <div className="flex items-center gap-2">
      <img 
        src="/logo.svg" 
        alt="BlackBelt AI" 
        className={className}
      />
      {showText && (
        <span className={textClassName}>BlackBelt AI</span>
      )}
    </div>
  );
}

/**
 * Logo Icon Only (for smaller spaces)
 */
export function LogoIcon({ className = "w-8 h-8" }) {
  return (
    <img 
      src="/logo.svg" 
      alt="BlackBelt AI" 
      className={className}
    />
  );
}

export default Logo;
